<app-header *ngIf="isReadonlyRoadmap"></app-header>
<div class="exit-view">
  <ion-button class="app-btn app-btn-margin left-125" *ngIf="isReadonlyRoadmap && !showHazardDetails"
    shape="round" fill="outline" color="primary" (click)="exitViewReadonlyRoadmap()">
    {{'Exit'|translate}}
  </ion-button>
</div>
<div *ngIf="!showHazardDetails" class="main-wrapper" [class.readonly-preview-mode]="isReadonlyRoadmap">
<div class="roadmap-container">
  <div class="roadmap-left-item">
    <ion-label class="roadmap-name-label"> {{'Roadmap Name' | translate }}*</ion-label>
    <ion-input type="text" class="roadmap-name-input"  name="roadmapName" placeholder="{{'Enter Roadmap Name'|translate}}"
      [(ngModel)]="roadmapName" [readonly]="isReadonlyRoadmap" (ionChange)="changeRoadmapName($event)" (ionBlur)="onRoadmapNameBlur()">
    </ion-input>
    <span class="validateError" *ngIf="!isRoadMapNameValid">
      {{'Please Enter a Valid Name'|translate}}
    </span>
    <span class="validateError" *ngIf="isDuplicateRoadmapName">
      {{'roadmap_name_already_exists'|translate}}
    </span>
  </div>
  <div class="roadmap-right-item">    
    <ion-button class="app-btn app-btn-margin margin-top-44" *ngIf="!isReadonlyRoadmap" shape="round" 
      fill="outline" color="primary" (click)="showRoadmapGrid()">
      {{'Exit'|translate}}
    </ion-button>
    <ion-button class="app-btn app-btn-margin margin-top-44" *ngIf="isReadonlyRoadmap" shape="round" 
      fill="outline" color="primary" (click)="checkConflictAndImport()">
      {{'import'|translate}}
    </ion-button>
  </div>
</div>
<div class="section-container" >
  <div class="section-left-item">
    <div class="sidebar">
      <div class="header">
        <span>{{ 'All_Sections' | translate}}</span>
        <div class="add-section-btn">
          <img tooltip="{{ 'Add Section' | translate }}" placement="bottom" (click)="addSection()"
            src="/assets/images/add-circle-outline.svg" alt="" class="add-btn plus-btn"
            [ngClass]="{'readonly-disabled': isReadonlyRoadmap || isAddingSection}" [style.pointer-events]="isReadonlyRoadmap || isAddingSection ? 'none' : 'auto'"
            [style.opacity]="isReadonlyRoadmap || isAddingSection ? 0.3 : 1" [disabled]="isReadonlyRoadmap || isAddingSection"
            role="button" [attr.tabindex]="isReadonlyRoadmap || isAddingSection ? -1 : 0" [attr.aria-label]="'Add Section' | translate"
            (keydown.enter)="isReadonlyRoadmap || isAddingSection ? null : addSection()"
            (keydown.space)="$event.preventDefault(); isReadonlyRoadmap || isAddingSection ? null : addSection()">
        </div>
      </div>
      <div *ngIf="sectionList?.length === 0">
        <img  src="/assets/images/Dynamic wizard.svg" alt="" class="empty-section-img">
      </div>
      <div cdkDropList (cdkDropListDropped)="isReadonlyRoadmap ? null : drop($event)" class="page-list">
        <div *ngIf="sections?.length > 0" class="scroll-container"  #sectionScrollContainer>
          <ul class="scrollable-list">
            <li *ngFor="let section of sections; let i = index; trackBy: trackByItemId" class="page-item draggable-item" 
              [class.selected]="i === selectedIndex" cdkDrag>
              <img *ngIf="!this.fromLibrary" 
                [src]="section.completionStatus === 'Completed' ? '/assets/icon/green-tick.svg' : 
                       section.completionStatus === 'InProgress' ? '/assets/icon/yellow-tick.svg' : 
                       '/assets/icon/grey-tick.svg'"
                [tooltip]="section.completionStatus === 'Completed' ? ('Complete' | translate) : 
                           section.completionStatus === 'InProgress' ? ('In Progress' | translate) : 
                           ('Not Started' | translate)"
                placement="bottom" 
                alt="tick" 
                class="tick-icon">
              <input class="section-block" placeholder="{{ 'add_section_name' | translate }}" readonly type="text" (keydown.enter)="selectSection(i)" (click)="selectSection(i)" [(ngModel)]="section.sectionName">
              <img tooltip="{{'More actions'  | translate }}" [ngClass]="{'readonly-disabled': isReadonlyRoadmap}" alt="" placement="bottom" class="more-actions" src="../../../assets/icon/more.svg" 
              (click)="isReadonlyRoadmap ? null : onClickKebab(section, i, $event, 'section-kebab')"
              role="button" [attr.tabindex]="isReadonlyRoadmap ? -1 : 0" [attr.aria-label]="'More actions' | translate"
              (keydown.enter)="isReadonlyRoadmap ? null : onClickKebab(section, i, $event, 'section-kebab')"
              (keydown.space)="$event.preventDefault(); isReadonlyRoadmap ? null : onClickKebab(section, i, $event, 'section-kebab')">
            </li>
          </ul>
        </div>
      </div>
      </div>
  </div>
  <div class="section-right-item" (pointerdown)="onSectionRightPointerDown($event)" (focusin)="onSectionRightFocusIn($event)">
    <ion-card class="roadmap-card">
      <div class="subsection-right-item" *ngIf="selectedSection != undefined">
         <div [class.hidden]="!isRoadmapCopied" class="copied-roadmap">{{'copied_roadmap_msg' | translate }}</div>
          <ion-button class="app-large-btn margin-right-16" [ngClass]="{'readonly-disabled': isReadonlyRoadmap || isAddingSubSection}"
            [disabled]="selectedSection.sectionName == '' || isAddingSubSection" shape="round" fill="solid" color="primary"
            (click)="isReadonlyRoadmap || isAddingSubSection ? null : addNewSection(selectedSection)" [attr.tabindex]="isReadonlyRoadmap || isAddingSubSection ? -1 : ''" role="button" (keydown.enter)="$event.preventDefault();isReadonlyRoadmap || isAddingSubSection ? null : addNewSection(selectedSection)" (keydown.space)="$event.preventDefault(); isReadonlyRoadmap || isAddingSubSection ? null : addNewSection(selectedSection)">
            {{ 'New Subsection' | translate }}
            <ion-icon slot="start" name="add-circle-outline"></ion-icon>
          </ion-button>
      </div>
      <div *ngIf="subSections.length == 0" class="empty-subsection">
        <img src="/assets/images/Group 20605.svg" alt="empty-subsection" class="empty-subsection-img">
      </div>
      <div class="subsection-block " *ngIf="subSections.length > 0"  #rightScrollContainer>
      <div cdkDropList (cdkDropListDropped)="isReadonlyRoadmap ? null :subSectionDrop($event,selectedSection)" class="page-list">
        <div class="subsection-container page-item draggable-item" *ngFor="let subSection of subSections; let i = index; trackBy: trackByItemId" cdkDrag>
          
          <div class="subsection-left-item">
            
          <div class="subsection-name">
            <img
              cdkDragHandle
              src="../../../assets/move-icon.svg"
              alt="Drag"
              class="drag-handle"      
              tooltip="{{ 'Drag to reorder' | translate }}"
              placement="bottom"
             
              [ngClass]="{'readonly-disabled': isReadonlyRoadmap}"        
            />
            <input
              id="subsection"
              type="text"
              placeholder="{{ 'enter_subsection_name' | translate }}"
              [readOnly]="isReadonlyRoadmap"
              [attr.data-focus-field]="'subsection-name'"
              [attr.data-subsection-key]="getSubSectionKey(subSection)"
              [(ngModel)]="subSection.subSectionName"
              (focus)="trackSubSectionNameFocus(subSection, $event)"
              (blur)="isReadonlyRoadmap ? null : onSubSectionNameBlur(subSection, selectedSection, $event)"
              class="subsection-input"
            />
             <img *ngIf="hasSubsectionPendingSteps(subSection) && !isTemplateRoadmap && !isAnsweredRoadmap" 
                src='/assets/icon/pending.svg' alt="pending" tooltip="{{'Pending Steps' | translate}}" placement="top" class="pending-subsection">
          <img tooltip="{{'More actions'  | translate }}" alt="" placement="bottom" [ngClass]="{'readonly-disabled': isReadonlyRoadmap}" class="more-actions" 
           src="../../../assets/icon/more.svg" (click)="isReadonlyRoadmap ? null : onClickKebab(subSection, i, $event, 'subsection-kebab')"
           role="button" [attr.tabindex]="isReadonlyRoadmap ? -1 : 0" [attr.aria-label]="'More actions' | translate"
           (keydown.enter)="isReadonlyRoadmap ? null : onClickKebab(subSection, i, $event, 'subsection-kebab')"
           (keydown.space)="$event.preventDefault(); isReadonlyRoadmap ? null : onClickKebab(subSection, i, $event, 'subsection-kebab')">
          </div>
        </div>
      
        <!-- Render steps only if they exist for the subsection -->
        <div class="accordion-card" *ngFor="let step of subSection.steps; let j = index; trackBy: trackByIndex">
          <ion-card class="accordion-block">
            <ion-item button (click)="toggleAccordion(step, j);" class="accordion-header" [class.accordion-open]="step.accordionOpen" lines="none">
              <ion-label>{{ step.stepBody }}</ion-label>
              <ion-icon slot="end" [name]="step.accordionOpen ? 'chevron-up' : 'chevron-down'"></ion-icon>
              <img *ngIf="hasPendingHazards(step) && !isTemplateRoadmap" 
                src='/assets/icon/pending.svg' alt="pending" tooltip="{{'Pending Hazards' | translate}}" placement="top">
              <div class="app-large-btn margin-12 rounded-center-div" shape="round" *ngIf="step.answer > 0" [ngClass]="fnGetOptionDetails(step.answer).selectColorClass">
                {{ fnGetOptionDetails(step.answer).optionName || translate }}
              </div>
            </ion-item>
        
            <!-- Render the content when the accordion is open -->
            <div *ngIf="step.accordionOpen" class="accordion-content">
              <div class="question-container" [ngClass]="{'readonly-disabled': isReadonlyRoadmap}">
                <div class="field-header">
                  <ion-label>{{ 'Question' | translate }} *</ion-label>
                  <div class="ai-writing-toolbar" *ngIf="aiFeaturesEnabled && (step.questionActive || isAdjustOpen(step, 'stepBody')) && !isReadonlyRoadmap && (step.stepBody?.trim() || hasAiHistory(step, subSection, 'stepBody'))">
                    <ng-container *ngIf="step.stepBody?.trim()">
                    <button type="button" class="ai-tool-btn" [disabled]="isFieldBusy(step, 'stepBody')" (mousedown)="$event.preventDefault()" (click)="onProofread(step, subSection, 'stepBody')">
                      <span class="ai-btn-icon-wrap">
                        <svg class="ai-btn-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true" [class.ai-icon-hidden]="step.qProofreadLoading">
                          <defs>
                            <linearGradient id="aiGradProofQ" x1="2" y1="2" x2="18" y2="18" gradientUnits="userSpaceOnUse">
                              <stop offset="0" stop-color="#FE4649"/>
                              <stop offset="0.4" stop-color="#CD5CC2"/>
                              <stop offset="0.7" stop-color="#8B68EF"/>
                              <stop offset="1" stop-color="#3E96FE"/>
                            </linearGradient>
                          </defs>
                          <circle cx="8.5" cy="8.5" r="5.5" stroke="url(#aiGradProofQ)" stroke-width="1.6"/>
                          <path d="M16.5 16.5l-4-4" stroke="url(#aiGradProofQ)" stroke-width="1.6" stroke-linecap="round"/>
                          <path d="M6 8.6l1.7 1.7 3.3-3.9" stroke="url(#aiGradProofQ)" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span class="ai-btn-spinner" [class.ai-spinner-visible]="step.qProofreadLoading"><span class="ai-btn-spinner-ring"></span></span>
                      </span>
                      <span class="ai-btn-label">{{ 'Proofread' | translate }}</span>
                    </button>
                    <span class="ai-tool-divider"></span>
                    <button type="button" class="ai-tool-btn" [disabled]="isFieldBusy(step, 'stepBody')" (mousedown)="$event.preventDefault()" (click)="onRewrite(step, subSection, 'stepBody')">
                      <span class="ai-btn-icon-wrap">
                        <svg class="ai-btn-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true" [class.ai-icon-hidden]="step.qRewriteLoading">
                          <defs>
                            <linearGradient id="aiGradRewriteQ" x1="2" y1="2" x2="18" y2="18" gradientUnits="userSpaceOnUse">
                              <stop offset="0" stop-color="#FE4649"/>
                              <stop offset="0.4" stop-color="#CD5CC2"/>
                              <stop offset="0.7" stop-color="#8B68EF"/>
                              <stop offset="1" stop-color="#3E96FE"/>
                            </linearGradient>
                          </defs>
                          <path d="M11.6 4.3a1.8 1.8 0 012.6 2.6L6.9 14.3l-3.4.8.8-3.4 7.3-7.4z" stroke="url(#aiGradRewriteQ)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M16.2 12.6l.6 1.4 1.4.6-1.4.6-.6 1.4-.6-1.4-1.4-.6 1.4-.6z" fill="url(#aiGradRewriteQ)"/>
                        </svg>
                        <span class="ai-btn-spinner" [class.ai-spinner-visible]="step.qRewriteLoading"><span class="ai-btn-spinner-ring"></span></span>
                      </span>
                      <span class="ai-btn-label">{{ 'Rewrite' | translate }}</span>
                    </button>
                    <span class="ai-tool-divider"></span>
                    <button type="button" class="ai-tool-btn" [class.ai-tool-btn--on]="isAdjustOpen(step, 'stepBody')" [disabled]="isFieldBusy(step, 'stepBody')" (mousedown)="$event.preventDefault()" (click)="onToggleAdjust(step, subSection, 'stepBody')">
                      <span class="ai-btn-icon-wrap">
                        <svg class="ai-btn-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true" [class.ai-icon-hidden]="isAdjustLoading(step, 'stepBody')">
                          <defs>
                            <linearGradient id="aiGradAdjustQ" x1="2" y1="2" x2="18" y2="18" gradientUnits="userSpaceOnUse">
                              <stop offset="0" stop-color="#FE4649"/>
                              <stop offset="0.4" stop-color="#CD5CC2"/>
                              <stop offset="0.7" stop-color="#8B68EF"/>
                              <stop offset="1" stop-color="#3E96FE"/>
                            </linearGradient>
                          </defs>
                          <path d="M3 6h8M15 6h2M3 14h2M9 14h8" stroke="url(#aiGradAdjustQ)" stroke-width="1.6" stroke-linecap="round"/>
                          <circle cx="13" cy="6" r="2.1" stroke="url(#aiGradAdjustQ)" stroke-width="1.6"/>
                          <circle cx="7" cy="14" r="2.1" stroke="url(#aiGradAdjustQ)" stroke-width="1.6"/>
                        </svg>
                        <span class="ai-btn-spinner" [class.ai-spinner-visible]="isAdjustLoading(step, 'stepBody')"><span class="ai-btn-spinner-ring"></span></span>
                      </span>
                      <span class="ai-btn-label">{{ 'Adjust' | translate }}</span>
                    </button>
                    </ng-container>
                    <ng-container *ngIf="hasAiHistory(step, subSection, 'stepBody')">
                      <span class="ai-tool-divider" *ngIf="step.stepBody?.trim()"></span>
                      <button type="button" class="ai-tool-btn ai-tool-btn--icon" [disabled]="!canUndoAi(step, subSection, 'stepBody')" tooltip="{{ 'Undo AI change' | translate }}" placement="top" (mousedown)="$event.preventDefault()" (click)="onUndoAi(step, subSection, 'stepBody')" [attr.aria-label]="'Undo AI change' | translate">
                        <svg class="ai-tool-glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5 5.5 5.5 0 0 1-5.5 5.5H11"/></svg>
                      </button>
                      <button type="button" class="ai-tool-btn ai-tool-btn--icon" [disabled]="!canRedoAi(step, subSection, 'stepBody')" tooltip="{{ 'Redo AI change' | translate }}" placement="top" (mousedown)="$event.preventDefault()" (click)="onRedoAi(step, subSection, 'stepBody')" [attr.aria-label]="'Redo AI change' | translate">
                        <svg class="ai-tool-glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 14 5-5-5-5"/><path d="M20 9H9.5A5.5 5.5 0 0 0 4 14.5 5.5 5.5 0 0 0 9.5 20H13"/></svg>
                      </button>
                      <span class="ai-tool-divider"></span>
                      <button type="button" class="ai-tool-btn ai-tool-btn--icon" tooltip="{{ 'Version history' | translate }}" placement="top" (mousedown)="$event.preventDefault()" (click)="openAiHistory(step, subSection, 'stepBody')" [attr.aria-label]="'Version history' | translate">
                        <svg class="ai-tool-glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/></svg>
                      </button>
                    </ng-container>
                  </div>
                </div>
                <div class="ai-field-ring-wrap" [class.ai-field-loading]="isFieldBusy(step, 'stepBody')">
                  <div class="ai-field-inner">
                    <ion-item lines="none">
                      <ion-textarea #qTextarea [readonly]="isReadonlyRoadmap"
                        [class.ai-field-revealing]="step.qRevealing"
                        [attr.data-focus-field]="'step-body'"
                        [attr.data-subsection-key]="getSubSectionKey(subSection)"
                        [attr.data-step-key]="getStepKey(step)"
                        [attr.tabindex]="isReadonlyRoadmap ? -1 : 0"
                        (ionFocus)="trackStepBodyFocus(step, subSection, $event); step.questionActive = true; onFieldFocusForGenerate(qTextarea, step, subSection, 'stepBody')"
                        (ionBlur)="step.questionActive = false; isReadonlyRoadmap ? null : onStepBodyBlur(step,subSection,selectedSection, $event); onFieldBlurForGenerate(); onFieldBlurForSelection()"
                        (mouseup)="onTextSelect(qTextarea, step, subSection, 'stepBody')"
                        (keyup)="onTextSelect(qTextarea, step, subSection, 'stepBody')"
                        (keydown)="onFieldSpaceForGenerate($event, qTextarea, step, subSection, 'stepBody')"
                        [placeholder]="isGenerateAvailable(step, 'stepBody') ? ('Press space to describe what you want, or just start typing…' | translate) : ('Add a Question' | translate)"
                        [(ngModel)]="step.stepBody">
                      </ion-textarea>
                    </ion-item>
                    <div class="ai-field-veil" *ngIf="isFieldEditing(step, 'stepBody') && !step.qRevealing">
                      <span class="ai-field-veil-text" *ngFor="let phrase of [aiLoadingPhrase]; trackBy: trackByPhrase">{{ phrase }}</span>
                    </div>
                  </div>
                </div>

                <!-- Adjust Dock for Question -->
                <app-ai-adjust-bar *ngIf="isAdjustOpen(step, 'stepBody')"
                  [loading]="isAdjustLoading(step, 'stepBody')"
                  [canUndo]="canUndoAi(step, subSection, 'stepBody')"
                  [error]="activeAdjust?.error || ''"
                  [applied]="!!activeAdjust?.applied"
                  [appliedSkillId]="activeAdjust?.appliedSkillId || ''"
                  (apply)="onAdjustApply(step, subSection, 'stepBody', $event)"
                  (undo)="onUndoAi(step, subSection, 'stepBody')"
                  (dismiss)="closeAdjust()"
                  (resultSuperseded)="clearAdjustResult()">
                </app-ai-adjust-bar>
              </div>
        
              <ion-list class="radio-buttons-row" [class.disabled]="fromLibrary">
                <ion-radio-group [ngModel]="getAnswer(step)"
                 [attr.data-focus-field]="'step-answer'"
                 [attr.data-subsection-key]="getSubSectionKey(subSection)"
                 [attr.data-step-key]="getStepKey(step)"
                 (ionChange)="isReadonlyRoadmap || fromLibrary ? null : onRadioSelectionChanged($event,step,subSection,selectedSection)"
                 name="compliance" [disabled]="isReadonlyRoadmap || fromLibrary"
                 [ngClass]="{'readonly-disabled': isReadonlyRoadmap}" mode="md">
                  <div class="radio-item" *ngFor="let option of complianceOptions">
                    <ion-radio slot="start" [value]="option.value" [disabled]="isReadonlyRoadmap || fromLibrary"></ion-radio>
                    <ion-label class="compliance-label" [ngClass]="{'compliance-label-bold': getAnswer(step) === option.value}">{{ option.label | translate }}</ion-label>
                  </div>
                </ion-radio-group>
              </ion-list>
        
              <div class="question-container" [class.disabled]="fromLibrary" [ngClass]="{'readonly-disabled': isReadonlyRoadmap}">
                <div class="field-header">
                  <ion-label>{{ 'Notes' | translate }}</ion-label>
                  <div class="ai-writing-toolbar" *ngIf="aiFeaturesEnabled && (step.notesActive || isAdjustOpen(step, 'stepNotes')) && !isReadonlyRoadmap && !fromLibrary && (step.stepNotes?.trim() || hasAiHistory(step, subSection, 'stepNotes'))">
                    <ng-container *ngIf="step.stepNotes?.trim()">
                    <button type="button" class="ai-tool-btn" [disabled]="isFieldBusy(step, 'stepNotes')" (mousedown)="$event.preventDefault()" (click)="onProofread(step, subSection, 'stepNotes')">
                      <span class="ai-btn-icon-wrap">
                        <svg class="ai-btn-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true" [class.ai-icon-hidden]="step.nProofreadLoading">
                          <defs>
                            <linearGradient id="aiGradProofN" x1="2" y1="2" x2="18" y2="18" gradientUnits="userSpaceOnUse">
                              <stop offset="0" stop-color="#FE4649"/>
                              <stop offset="0.4" stop-color="#CD5CC2"/>
                              <stop offset="0.7" stop-color="#8B68EF"/>
                              <stop offset="1" stop-color="#3E96FE"/>
                            </linearGradient>
                          </defs>
                          <circle cx="8.5" cy="8.5" r="5.5" stroke="url(#aiGradProofN)" stroke-width="1.6"/>
                          <path d="M16.5 16.5l-4-4" stroke="url(#aiGradProofN)" stroke-width="1.6" stroke-linecap="round"/>
                          <path d="M6 8.6l1.7 1.7 3.3-3.9" stroke="url(#aiGradProofN)" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <span class="ai-btn-spinner" [class.ai-spinner-visible]="step.nProofreadLoading"><span class="ai-btn-spinner-ring"></span></span>
                      </span>
                      <span class="ai-btn-label">{{ 'Proofread' | translate }}</span>
                    </button>
                    <span class="ai-tool-divider"></span>
                    <button type="button" class="ai-tool-btn" [disabled]="isFieldBusy(step, 'stepNotes')" (mousedown)="$event.preventDefault()" (click)="onRewrite(step, subSection, 'stepNotes')">
                      <span class="ai-btn-icon-wrap">
                        <svg class="ai-btn-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true" [class.ai-icon-hidden]="step.nRewriteLoading">
                          <defs>
                            <linearGradient id="aiGradRewriteN" x1="2" y1="2" x2="18" y2="18" gradientUnits="userSpaceOnUse">
                              <stop offset="0" stop-color="#FE4649"/>
                              <stop offset="0.4" stop-color="#CD5CC2"/>
                              <stop offset="0.7" stop-color="#8B68EF"/>
                              <stop offset="1" stop-color="#3E96FE"/>
                            </linearGradient>
                          </defs>
                          <path d="M11.6 4.3a1.8 1.8 0 012.6 2.6L6.9 14.3l-3.4.8.8-3.4 7.3-7.4z" stroke="url(#aiGradRewriteN)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M16.2 12.6l.6 1.4 1.4.6-1.4.6-.6 1.4-.6-1.4-1.4-.6 1.4-.6z" fill="url(#aiGradRewriteN)"/>
                        </svg>
                        <span class="ai-btn-spinner" [class.ai-spinner-visible]="step.nRewriteLoading"><span class="ai-btn-spinner-ring"></span></span>
                      </span>
                      <span class="ai-btn-label">{{ 'Rewrite' | translate }}</span>
                    </button>
                    <span class="ai-tool-divider"></span>
                    <button type="button" class="ai-tool-btn" [class.ai-tool-btn--on]="isAdjustOpen(step, 'stepNotes')" [disabled]="isFieldBusy(step, 'stepNotes')" (mousedown)="$event.preventDefault()" (click)="onToggleAdjust(step, subSection, 'stepNotes')">
                      <span class="ai-btn-icon-wrap">
                        <svg class="ai-btn-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true" [class.ai-icon-hidden]="isAdjustLoading(step, 'stepNotes')">
                          <defs>
                            <linearGradient id="aiGradAdjustN" x1="2" y1="2" x2="18" y2="18" gradientUnits="userSpaceOnUse">
                              <stop offset="0" stop-color="#FE4649"/>
                              <stop offset="0.4" stop-color="#CD5CC2"/>
                              <stop offset="0.7" stop-color="#8B68EF"/>
                              <stop offset="1" stop-color="#3E96FE"/>
                            </linearGradient>
                          </defs>
                          <path d="M3 6h8M15 6h2M3 14h2M9 14h8" stroke="url(#aiGradAdjustN)" stroke-width="1.6" stroke-linecap="round"/>
                          <circle cx="13" cy="6" r="2.1" stroke="url(#aiGradAdjustN)" stroke-width="1.6"/>
                          <circle cx="7" cy="14" r="2.1" stroke="url(#aiGradAdjustN)" stroke-width="1.6"/>
                        </svg>
                        <span class="ai-btn-spinner" [class.ai-spinner-visible]="isAdjustLoading(step, 'stepNotes')"><span class="ai-btn-spinner-ring"></span></span>
                      </span>
                      <span class="ai-btn-label">{{ 'Adjust' | translate }}</span>
                    </button>
                    </ng-container>
                    <ng-container *ngIf="hasAiHistory(step, subSection, 'stepNotes')">
                      <span class="ai-tool-divider" *ngIf="step.stepNotes?.trim()"></span>
                      <button type="button" class="ai-tool-btn ai-tool-btn--icon" [disabled]="!canUndoAi(step, subSection, 'stepNotes')" tooltip="{{ 'Undo AI change' | translate }}" placement="top" (mousedown)="$event.preventDefault()" (click)="onUndoAi(step, subSection, 'stepNotes')" [attr.aria-label]="'Undo AI change' | translate">
                        <svg class="ai-tool-glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5 5.5 5.5 0 0 1-5.5 5.5H11"/></svg>
                      </button>
                      <button type="button" class="ai-tool-btn ai-tool-btn--icon" [disabled]="!canRedoAi(step, subSection, 'stepNotes')" tooltip="{{ 'Redo AI change' | translate }}" placement="top" (mousedown)="$event.preventDefault()" (click)="onRedoAi(step, subSection, 'stepNotes')" [attr.aria-label]="'Redo AI change' | translate">
                        <svg class="ai-tool-glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 14 5-5-5-5"/><path d="M20 9H9.5A5.5 5.5 0 0 0 4 14.5 5.5 5.5 0 0 0 9.5 20H13"/></svg>
                      </button>
                      <span class="ai-tool-divider"></span>
                      <button type="button" class="ai-tool-btn ai-tool-btn--icon" tooltip="{{ 'Version history' | translate }}" placement="top" (mousedown)="$event.preventDefault()" (click)="openAiHistory(step, subSection, 'stepNotes')" [attr.aria-label]="'Version history' | translate">
                        <svg class="ai-tool-glyph" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/></svg>
                      </button>
                    </ng-container>
                  </div>
                </div>
                <div class="ai-field-ring-wrap" [class.ai-field-loading]="isFieldBusy(step, 'stepNotes')">
                  <div class="ai-field-inner">
                    <ion-item lines="none">
                      <ion-textarea #nTextarea name="notes"
                       [class.ai-field-revealing]="step.nRevealing"
                       [attr.data-focus-field]="'step-notes'"
                       [attr.data-subsection-key]="getSubSectionKey(subSection)"
                       [attr.data-step-key]="getStepKey(step)"
                       [readonly]="isReadonlyRoadmap || fromLibrary"
                       [attr.tabindex]="isReadonlyRoadmap || fromLibrary ? -1 : 0"
                       [placeholder]="isGenerateAvailable(step, 'stepNotes') ? ('Press space to describe what you want, or just start typing…' | translate) : ''"
                       [(ngModel)]="step.stepNotes"
                       (ionFocus)="trackStepNotesFocus(step, subSection, $event); step.notesActive = true; onFieldFocusForGenerate(nTextarea, step, subSection, 'stepNotes')"
                       (ionBlur)="step.notesActive = false; isReadonlyRoadmap || fromLibrary ? null : onNoteBlur($event,step,subSection,selectedSection); onFieldBlurForGenerate(); onFieldBlurForSelection()"
                       (mouseup)="onTextSelect(nTextarea, step, subSection, 'stepNotes')" (keyup)="onTextSelect(nTextarea, step, subSection, 'stepNotes')"
                       (keydown)="onFieldSpaceForGenerate($event, nTextarea, step, subSection, 'stepNotes')"></ion-textarea>
                      <ion-icon *ngIf="step.padLock"  tooltip="{{ 'padlock_notes_included' | translate }}" src="../../../assets/Pdf_icon.svg" placement="left"  class="lock-icon" (click)="isReadonlyRoadmap || fromLibrary ? null : onPadlockChange(false,step,subSection,selectedSection)"
                        role="button" [attr.tabindex]="isReadonlyRoadmap || fromLibrary ? -1 : 0" [attr.aria-label]="'Unlock notes' | translate"
                        (keydown.enter)="isReadonlyRoadmap || fromLibrary ? null : onPadlockChange(false,step,subSection,selectedSection)"
                        (keydown.space)="$event.preventDefault(); isReadonlyRoadmap || fromLibrary ? null : onPadlockChange(false,step,subSection,selectedSection)"></ion-icon>
                      <ion-icon *ngIf="!step.padLock"  tooltip="{{ 'padlock_notes_notincluded' | translate }}" src="../../../assets/Lock_icon.svg" placement="left" class="lock-icon" (click)="isReadonlyRoadmap || fromLibrary ? null : onPadlockChange(true,step,subSection,selectedSection)"
                        role="button" [attr.tabindex]="isReadonlyRoadmap || fromLibrary ? -1 : 0" [attr.aria-label]="'Lock notes' | translate"
                        (keydown.enter)="isReadonlyRoadmap || fromLibrary ? null : onPadlockChange(true,step,subSection,selectedSection)"
                        (keydown.space)="$event.preventDefault(); isReadonlyRoadmap || fromLibrary ? null : onPadlockChange(true,step,subSection,selectedSection)"></ion-icon>
                    </ion-item>
                    <div class="ai-field-veil" *ngIf="isFieldEditing(step, 'stepNotes') && !step.nRevealing">
                      <span class="ai-field-veil-text" *ngFor="let phrase of [aiLoadingPhrase]; trackBy: trackByPhrase">{{ phrase }}</span>
                    </div>
                  </div>
                </div>

                <!-- Adjust Dock for Notes -->
                <app-ai-adjust-bar *ngIf="isAdjustOpen(step, 'stepNotes')"
                  [loading]="isAdjustLoading(step, 'stepNotes')"
                  [canUndo]="canUndoAi(step, subSection, 'stepNotes')"
                  [error]="activeAdjust?.error || ''"
                  [applied]="!!activeAdjust?.applied"
                  [appliedSkillId]="activeAdjust?.appliedSkillId || ''"
                  (apply)="onAdjustApply(step, subSection, 'stepNotes', $event)"
                  (undo)="onUndoAi(step, subSection, 'stepNotes')"
                  (dismiss)="closeAdjust()"
                  (resultSuperseded)="clearAdjustResult()">
                </app-ai-adjust-bar>
                <ion-text class="validate-error" *ngIf="(step?.stepNotes==null || step?.stepNotes == '') && step?.answer == 2">
                  {{ 'required' | translate}}
                </ion-text>
                <ion-text class="validate-error" *ngIf="step?.stepNotesInvalid">
                  {{ 'only_spaces_not_allowed' | translate}}
                </ion-text>
              </div>
              <div class="button-container" *ngIf="step.answer == 4">
                <ion-button class="app-large-btn add-hazard-details-btn float-left margin-top-12" [ngClass]="{'readonly-disabled': isReadonlyRoadmap}" shape="round" fill="solid" color="primary"
                  (click)="isReadonlyRoadmap ? null : copyHazard(j,step,subSection,selectedSection)"
                  [attr.tabindex]="isReadonlyRoadmap ? -1 : 0"
                  role="button"
                  (keydown.enter)="isReadonlyRoadmap ? null : copyHazard(j,step,subSection,selectedSection)"
                  (keydown.space)="$event.preventDefault(); isReadonlyRoadmap ? null : copyHazard(j,step,subSection,selectedSection)">
                  <ion-icon slot="start" name="add-circle-outline"></ion-icon>
                  {{ 'Add Hazard Details' | translate }}
                </ion-button>
                <div *ngIf="step?.hazard?.length>0">
                  <ion-label class="hazards">{{ 'Hazards' | translate }}</ion-label>
                  <ion-row *ngFor="let hazard of step?.hazard; let j=index">
                    <ion-col size="12" (click)="getHazardDetails(hazard,step)"
                      role="button" tabindex="0" [attr.aria-label]="'Open hazard details' | translate"
                      (keydown.enter)="getHazardDetails(hazard,step)"
                      (keydown.space)="$event.preventDefault(); getHazardDetails(hazard,step)">
                      <ion-card class="list-card ion-no-margin"
                        [ngStyle]="{'border-left': '7px solid ' + (hazard.completionStatus === 'Completed' ? 'var(--g-200-light-green)' : 'var(--y-400-mustard)')}">
                        <ion-row class="ion-align-items-center">
                          <ion-col >
                            <ion-label class="hazard-name">{{hazard.hazardName}}</ion-label>
                          </ion-col>
                          <ion-col size="auto" class="hazard-actions-col">
                            <span class="completion-status-badge" 
                              [ngClass]="{
                                'status-completed': hazard.completionStatus === 'Completed',
                                'status-in-progress': hazard.completionStatus === 'InProgress',
                                'status-not-started': hazard.completionStatus !== 'Completed' && hazard.completionStatus !== 'InProgress'
                              }">
                              {{ (hazard.completionStatus === 'Completed' ? 'Completed' : 
                                  hazard.completionStatus === 'InProgress' ? 'In Progress' : 'Not Started') | translate }}
                            </span>
                            <ion-icon *ngIf="hazard.id" class="trash-icon delete-icon-transition" [ngClass]="{'readonly-disabled': isReadonlyRoadmap}" color="primary" (click)="$event.stopPropagation(); isReadonlyRoadmap ? null : deleteHazardConfirmation(hazard,j,step)" tooltip="{{'Delete_Hazard' | translate }}"
                              role="button" [attr.tabindex]="isReadonlyRoadmap ? -1 : 0" [attr.aria-label]="'Delete hazard' | translate"
                              (keydown.enter)="$event.preventDefault(); $event.stopPropagation(); isReadonlyRoadmap ? null : deleteHazardConfirmation(hazard,j,step)"
                              (keydown.space)="$event.preventDefault(); $event.stopPropagation(); isReadonlyRoadmap ? null : deleteHazardConfirmation(hazard,j,step)"
                              placement="bottom" name="trash-outline">
                            </ion-icon>
                          </ion-col>
                        </ion-row>
                      </ion-card>
                    </ion-col>
                  </ion-row>
              </div>
              </div>
            <div class="image-blocks-container">
              <div class="image-block" *ngIf="getAnswer(step) === 'yesCompliant'"> 
                <app-image-upload
                  class="upload-images"
                  [class.readonly-disabled]="isReadonlyRoadmap"
                  [width]="'150px'"
                  [height]="'150px'"
                  [accept]="'.png,.jpeg,.jpg'"
                  [placeholder]="'drag_and_upload_images'"
                  [multiple]="true"
                  [maxFiles]="10"
                  [maxFileSize]="5242880"
                  [attr.data-focus-field]="'image-upload'"
                  data-image-control="upload"
                  [attr.data-subsection-key]="getSubSectionKey(subSection)"
                  [attr.data-step-key]="getStepKey(step)"
                  [attr.data-image-type]="'5'"
                  [style.pointer-events]="isReadonlyRoadmap ? 'none' : 'auto'"
                  [style.opacity]="isReadonlyRoadmap ? 0.3 : 1"
                  (filesSelected)="onCompliantImagesSelected($event, step, subSection, selectedSection)"
                ></app-image-upload>
                <div class="img-block" *ngIf="previewCompliantImages.length > 0">
                  <div class="carosal-block">
                    <div class="ra-carousel-container">
                      <div class="ra-carousel-viewport"
                        data-carousel-type="compliant"
                        (pointerdown)="onCarouselPointerDown($event, 'compliant')"
                        (pointermove)="onCarouselPointerMove($event)"
                        (pointerup)="onCarouselPointerUp($event)"
                        (pointercancel)="onCarouselPointerUp($event)"
                        (wheel)="onCarouselWheel($event, 'compliant')">
                        <div class="ra-carousel-inner" tabindex="1">
                        <div class="ra-carousel-item" *ngFor="let image of previewCompliantImages; let i = index; trackBy: trackByImageId">
                          <div class="ra-carousel ra-chip">
                            <div class="ra-chip-img position-relative" [ngClass]="{'disabled-image': image.is_view}">
                              <img src="{{ image.url }}" alt="compliant-image" class="image" draggable="false" (load)="onRoadmapImageRendered()">
                              <div class="view-only-overlay" *ngIf="image.is_view">
                                <span class="img-upload-txt" [tooltip]="'view_only' | translate" placement="bottom">{{ 'view_only' | translate }}</span>
                              </div>
                              <button *ngIf="!image.is_view" type="button" class="delete-icon" [ngClass]="{'readonly-disabled': isReadonlyRoadmap}" data-focus-field="image-upload" data-image-control="remove" [attr.data-subsection-key]="getSubSectionKey(subSection)" [attr.data-step-key]="getStepKey(step)" [attr.data-image-type]="5" [attr.data-image-key]="image.id || image.url || image.fileName" (click)="isReadonlyRoadmap ? null :deleteImageConfirmation(image, 5, step, subSection, selectedSection)" tooltip="{{ 'Remove' | translate }}" placement="bottom"
                                (focus)="onImageControlFocus(image, 5, step, subSection, 'remove')"
                                [attr.tabindex]="isReadonlyRoadmap ? -1 : 0" [attr.aria-label]="'Remove image' | translate">
                                <ion-icon name="close-circle-outline" aria-hidden="true"></ion-icon>
                              </button>
                            </div>
                            <input type="text" class="image-name-input" 
                              [(ngModel)]="image.fileName" 
                              [attr.tabindex]="isReadonlyRoadmap ? -1 : 0"
                              [readonly]="image.is_view || isReadonlyRoadmap"
                              [ngClass]="{'readonly-input': image.is_view || isReadonlyRoadmap}"
                              [attr.data-focus-field]="'image-upload'"
                              [attr.data-subsection-key]="getSubSectionKey(subSection)"
                              [attr.data-step-key]="getStepKey(step)"
                              [attr.data-image-type]="5"
                              data-image-control="name"
                              [attr.data-image-key]="image.id || image.url || image.fileName"
                              (focus)="onImageControlFocus(image, 5, step, subSection, 'name'); onRoadmapImageNameFocus(image, 'compliant', step, subSection, $event)"
                              (blur)="onRoadmapImageNameBlur(image, 'compliant', step, subSection, selectedSection, $event)"
                              placeholder="{{ 'image_name' | translate }}">
                          </div>
                        </div>
                        </div>
                      </div>
                      <div class="carousel-button ra-carousel-btn ra-prev-btn" *ngIf="previewCompliantImages.length > 4" (click)="prevSlide('compliant')"
                        role="button" tabindex="0" [attr.aria-label]="'Previous compliant image' | translate"
                        (keydown.enter)="prevSlide('compliant')"
                        (keydown.space)="$event.preventDefault(); prevSlide('compliant')">
                        <img src="assets/icon/left-arrow.png" alt="left-arrow" class="arrow-icon">
                      </div>
                      <div class="carousel-button ra-carousel-btn ra-next-btn" *ngIf="previewCompliantImages.length > 4" (click)="nextSlide('compliant')"
                        role="button" tabindex="0" [attr.aria-label]="'Next compliant image' | translate"
                        (keydown.enter)="nextSlide('compliant')"
                        (keydown.space)="$event.preventDefault(); nextSlide('compliant')">
                        <img src="assets/icon/right-arrow.png" alt="right-arrow" class="arrow-icon">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="image-block" *ngIf="getAnswer(step) === 'notCompliant'">
                <app-image-upload
                  class="upload-images"
                  [class.readonly-disabled]="isReadonlyRoadmap"
                  [width]="'150px'"
                  [height]="'150px'"
                  [accept]="'.png,.jpeg,.jpg'"
                  [placeholder]="'drag_and_upload_images'"
                  [multiple]="true"
                  [maxFiles]="10"
                  [maxFileSize]="5242880"
                  [attr.data-focus-field]="'image-upload'"
                  data-image-control="upload"
                  [attr.data-subsection-key]="getSubSectionKey(subSection)"
                  [attr.data-step-key]="getStepKey(step)"
                  [attr.data-image-type]="'6'"
                  [style.pointer-events]="isReadonlyRoadmap ? 'none' : 'auto'"
                  [style.opacity]="isReadonlyRoadmap ? 0.3 : 1"
                  (filesSelected)="onNotCompliantImagesSelected($event, step, subSection, selectedSection)"
                ></app-image-upload>
                <div class="img-block" *ngIf="previewNotCompliantImages.length > 0">
                  <div class="carosal-block">
                    <div class="ra-carousel-container">
                      <div class="ra-carousel-viewport"
                        data-carousel-type="notCompliant"
                        (pointerdown)="onCarouselPointerDown($event, 'notCompliant')"
                        (pointermove)="onCarouselPointerMove($event)"
                        (pointerup)="onCarouselPointerUp($event)"
                        (pointercancel)="onCarouselPointerUp($event)"
                        (wheel)="onCarouselWheel($event, 'notCompliant')">
                      <div class="ra-carousel-inner" tabindex="1">
                        <div class="ra-carousel-item" *ngFor="let image of previewNotCompliantImages; let i = index; trackBy: trackByImageId">
                          <div class="ra-carousel ra-chip">
                            <div class="ra-chip-img position-relative" [ngClass]="{'disabled-image': image.is_view}">
                              <img src="{{ image.url }}" alt="not-compliant-image" class="image" draggable="false" (load)="onRoadmapImageRendered()">
                              <div class="view-only-overlay" *ngIf="image.is_view">
                                <span class="img-upload-txt" [tooltip]="'view_only' | translate" placement="bottom">{{ 'view_only' | translate }}</span>
                              </div>
                              <button *ngIf="!image.is_view" type="button" class="delete-icon" [ngClass]="{'readonly-disabled': isReadonlyRoadmap}" data-focus-field="image-upload" data-image-control="remove" [attr.data-subsection-key]="getSubSectionKey(subSection)" [attr.data-step-key]="getStepKey(step)" [attr.data-image-type]="6" [attr.data-image-key]="image.id || image.url || image.fileName" (click)="deleteImageConfirmation(image, 6, step, subSection, selectedSection)" tooltip="{{ 'Remove' | translate }}" placement="bottom"
                                (focus)="onImageControlFocus(image, 6, step, subSection, 'remove')"
                                [attr.tabindex]="isReadonlyRoadmap ? -1 : 0" [attr.aria-label]="'Remove image' | translate">
                                <ion-icon name="close-circle-outline" aria-hidden="true"></ion-icon>
                              </button>
                            </div>
                            <input type="text" class="image-name-input" 
                              [(ngModel)]="image.fileName" [attr.tabindex]="isReadonlyRoadmap ? -1 : 0"
                              [readonly]="image.is_view || isReadonlyRoadmap"
                              [ngClass]="{'readonly-input': image.is_view || isReadonlyRoadmap}"
                              [attr.data-focus-field]="'image-upload'"
                              [attr.data-subsection-key]="getSubSectionKey(subSection)"
                              [attr.data-step-key]="getStepKey(step)"
                              [attr.data-image-type]="6"
                              data-image-control="name"
                              [attr.data-image-key]="image.id || image.url || image.fileName"
                              (focus)="onImageControlFocus(image, 6, step, subSection, 'name'); onRoadmapImageNameFocus(image, 'notCompliant', step, subSection, $event)"
                              (blur)="onRoadmapImageNameBlur(image, 'notCompliant', step, subSection, selectedSection, $event)"
                              placeholder="{{ 'image_name' | translate }}">
                          </div>
                        </div>
                        </div>
                      </div>
                      <div class="carousel-button ra-carousel-btn ra-prev-btn" *ngIf="previewNotCompliantImages.length > 4" (click)="prevSlide('notCompliant')"
                        role="button" tabindex="0" [attr.aria-label]="'Previous not compliant image' | translate"
                        (keydown.enter)="prevSlide('notCompliant')"
                        (keydown.space)="$event.preventDefault(); prevSlide('notCompliant')">
                        <img src="assets/icon/left-arrow.png" alt="left-arrow" class="arrow-icon">
                      </div>
                      <div class="carousel-button ra-carousel-btn ra-next-btn" *ngIf="previewNotCompliantImages.length > 4" (click)="nextSlide('notCompliant')"
                        role="button" tabindex="0" [attr.aria-label]="'Next not compliant image' | translate"
                        (keydown.enter)="nextSlide('notCompliant')"
                        (keydown.space)="$event.preventDefault(); nextSlide('notCompliant')">
                        <img src="assets/icon/right-arrow.png" alt="right-arrow" class="arrow-icon">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ion-card>
          <img tooltip="{{'More actions'  | translate }}" alt="" placement="bottom" class="more-actions " [ngClass]="{'readonly-disabled': isReadonlyRoadmap}" 
          src="../../../assets/icon/more.svg" (click)="isReadonlyRoadmap ? null :onClickKebab(step, j, $event, 'step-kebab', subSection)"
          role="button" [attr.tabindex]="isReadonlyRoadmap ? -1 : 0" [attr.aria-label]="'More actions' | translate"
          (keydown.enter)="isReadonlyRoadmap ? null : onClickKebab(step, j, $event, 'step-kebab', subSection)"
          (keydown.space)="$event.preventDefault(); isReadonlyRoadmap ? null : onClickKebab(step, j, $event, 'step-kebab', subSection)">
        </div>
        <div>
          <ion-button class="app-btn margin-right-16" [ngClass]="{'readonly-disabled': isReadonlyRoadmap || isAddingStep}" shape="round" fill="solid" color="primary" [disabled]="isAddingStep"
            (click)="isReadonlyRoadmap || isAddingStep ? null : addNewStep(i,subSection,selectedSection)"
            [attr.tabindex]="isReadonlyRoadmap || isAddingStep ? -1 : ''">
            {{ 'New Step' | translate }}
            <ion-icon slot="start" name='add-circle-outline'></ion-icon>
          </ion-button>
        </div>
      </div>
      </div>   
      </div>        
    </ion-card>
  </div>
</div>
</div>

<!-- Single shared selection-triggered AI bubble: one instance for the whole
     page, positioned fixed, so it escapes every overflow:hidden ancestor
     (roadmap-card / section-container / subsection-block all clip).
     Horizontal icon+label row (like Medium's real inline selection
     toolbar), not a vertical list — two quick actions read as a toolbar,
     not a menu to browse. -->
<div class="ai-selection-menu" *ngIf="aiFeaturesEnabled && selectionToolbar" [style.top.px]="selectionToolbar.top" [style.left.px]="selectionToolbar.left" (mousedown)="$event.preventDefault()">
  <button type="button" class="ai-selection-row" (click)="onProofreadSelection()">
    <svg class="ai-selection-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="aiSelGradProof" x1="2" y1="2" x2="18" y2="18" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="#FE4649"/>
          <stop offset="0.4" stop-color="#CD5CC2"/>
          <stop offset="0.7" stop-color="#8B68EF"/>
          <stop offset="1" stop-color="#3E96FE"/>
        </linearGradient>
      </defs>
      <circle cx="8.5" cy="8.5" r="5.5" stroke="url(#aiSelGradProof)" stroke-width="1.6"/>
      <path d="M16.5 16.5l-4-4" stroke="url(#aiSelGradProof)" stroke-width="1.6" stroke-linecap="round"/>
      <path d="M6 8.6l1.7 1.7 3.3-3.9" stroke="url(#aiSelGradProof)" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span>Proofread</span>
  </button>
  <span class="ai-selection-divider"></span>
  <button type="button" class="ai-selection-row" (click)="onRewriteSelection()">
    <svg class="ai-selection-icon" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="aiSelGradRewrite" x1="2" y1="2" x2="18" y2="18" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="#FE4649"/>
          <stop offset="0.4" stop-color="#CD5CC2"/>
          <stop offset="0.7" stop-color="#8B68EF"/>
          <stop offset="1" stop-color="#3E96FE"/>
        </linearGradient>
      </defs>
      <path d="M11.6 4.3a1.8 1.8 0 012.6 2.6L6.9 14.3l-3.4.8.8-3.4 7.3-7.4z" stroke="url(#aiSelGradRewrite)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M16.2 12.6l.6 1.4 1.4.6-1.4.6-.6 1.4-.6-1.4-1.4-.6 1.4-.6z" fill="url(#aiSelGradRewrite)"/>
    </svg>
    <span>Rewrite</span>
  </button>
</div>

<!-- Same bubble mechanism as the selection menu above, spawned on focus of
     an EMPTY field instead of on text selection — "describe what you want"
     takes the exact slot Proofread/Rewrite would once there's text. Not an
     overlay on the field (nothing to overlap/hide it): the textarea stays
     completely normal and typeable the whole time. -->
<div class="ai-generate-bubble" [class.ai-generate-bubble-busy]="generateBubble.loading" *ngIf="aiFeaturesEnabled && generateBubble" [style.top.px]="generateBubble.top" [style.left.px]="generateBubble.left">
  <svg class="ai-generate-icon" [class.ai-icon-hidden]="generateBubble.loading" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <defs>
      <linearGradient id="aiGradPencilBubble" x1="2" y1="18" x2="18" y2="2" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#FE4649"/>
        <stop offset="0.4" stop-color="#CD5CC2"/>
        <stop offset="0.7" stop-color="#8B68EF"/>
        <stop offset="1" stop-color="#3E96FE"/>
      </linearGradient>
    </defs>
    <path d="M11.6 4.3a1.8 1.8 0 012.6 2.6L6.9 14.3l-3.4.8.8-3.4 7.3-7.4z" stroke="url(#aiGradPencilBubble)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  <span class="ai-generate-input-wrap">
    <textarea class="ai-generate-input" rows="1" placeholder="{{ 'Describe what you want to write…' | translate }}"
      [readonly]="generateBubble.loading"
      [(ngModel)]="generateBubble.prompt"
      (input)="onGenerateInput($event)"
      (blur)="onFieldBlurForGenerate()"
      (keydown.enter)="$event.preventDefault(); onGenerateFromBubble()"></textarea>
    <!-- Composing status lives HERE, over the bubble's own input, not on
         the field below — while generating, the field is still empty, so
         there's nothing there to veil. This is where the user is looking. -->
    <div class="ai-generate-status" *ngIf="generateBubble.loading">
      <span class="ai-generate-status-text" *ngFor="let phrase of [aiComposingPhrase]; trackBy: trackByPhrase">{{ phrase }}</span>
    </div>
    <!-- Docked inside the pill, not a separate element beside it (that read
         as a stray oversized arrow). Only appears once there's something to
         send — iMessage/ChatGPT's composer pattern — so the resting bubble
         stays just a clean input; Enter still works either way. -->
    <button type="button" class="ai-generate-send" [class.ai-generate-send-visible]="generateBubble.prompt?.trim() || generateBubble.loading" [disabled]="generateBubble.loading" (mousedown)="$event.preventDefault()" (click)="onGenerateFromBubble()" [attr.aria-label]="'Generate' | translate">
      <svg class="ai-generate-send-icon" [class.ai-icon-hidden]="generateBubble.loading" viewBox="0 0 20 20" fill="none" aria-hidden="true">
        <path d="M10 15.5V5.5M10 5.5L5.5 10M10 5.5l4.5 4.5" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span class="ai-btn-spinner" [class.ai-spinner-visible]="generateBubble.loading"><span class="ai-generate-send-spinner-ring"></span></span>
    </button>
  </span>
</div>

<app-add-hazard *ngIf="showHazardDetails"
 [hazardInfo]="hazardInfo" 
 [selLanguage]="selectedLanguage"
 [hazardId]="hazardId" 
 [stepId]="stepId" 
 [roadmapId]="roadmapId" 
 [version]="version"
 [isReadonlyHazard]="isReadonlyHazard"
 [machineModes]="machineModeList"
 [serviceMachineId]="serviceMachineId"
 [breadcrumbSectionName]="currentBreadcrumb.sectionName"
 [breadcrumbSubSectionName]="currentBreadcrumb.subSectionName"
 [breadcrumbStepName]="currentBreadcrumb.stepName"
 (exitHazardDetails)="fnExitHazardDetails($event)"></app-add-hazard>

